import { USER_TOKEN_TYPES as CE_USER_TOKEN_TYPES } from '~/filtered_search/constants';

export const USER_TOKEN_TYPES = [...CE_USER_TOKEN_TYPES, 'approver'];
